var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83594 6.5L13.0547 10.7188C13.2891 10.9531 13.2891 11.3828 13.0547 11.6172L12.0781 12.5938C11.8438 12.8281 11.4141 12.8281 11.1797 12.5938L7 8.375L2.78125 12.5938C2.54688 12.8281 2.11719 12.8281 1.88281 12.5938L0.90625 11.6172C0.671875 11.3828 0.671875 10.9531 0.90625 10.7188L5.125 6.5L0.90625 2.32031C0.671875 2.08594 0.671875 1.65625 0.90625 1.42188L1.88281 0.445312C2.11719 0.210938 2.54688 0.210938 2.78125 0.445312L7 4.66406L11.1797 0.445312C11.4141 0.210938 11.8438 0.210938 12.0781 0.445312L13.0547 1.42188C13.2891 1.65625 13.2891 2.08594 13.0547 2.32031L8.83594 6.5Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBold);
export default __webpack_public_path__ + "static/media/crossBold.321ab7e20a1f0374b9c96da6cf29a8a5.svg";
export { ForwardRef as ReactComponent };